<template>
    <layout-main :banner="banner" subtitle="智慧病房交互系统">
        <template v-slot:content>
            <p class="text">智慧病房交互系统作为病区信息集成和协调中枢，融合医院多个信息系统，沟通医、患、护三方联系的新一代床旁交互系统。平台将零散的护理数据进行整合，统一显示于智能大屏，医护人员可通过智能大屏实时查看病区情况、患者信息、输液情况、医嘱执行等，实现了风险主动发现、及时预警和提前干预，保障了医疗信息的及时性、一致性和全面性，简化了工作流程，提升了病房管理质量。</p>
            <img src="@/assets/ward/image1.png" alt="" class="image1">
            <div class="title weight"> 产品特征 </div>
            <p class="text weight">· 精准查询检查报告、费用查询、智能提醒、健康宣教等内容，提升就医体验</p>
            <p class="text weight">· 医护患交互无障碍，可实时呼叫医护人员</p>
            <p class="text weight">· 点餐、娱乐、视频等多功能，为患者提供多元化服务</p>
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/ward/banner.png'
export default {
  components: {
      layoutMain,
      
  },
  data () {
      return {
          banner: banner
      }
  }
}
</script>
<style lang="scss" scoped>
.weight{
    font-weight: 600;
    line-height: 3 !important;
}
.title{ 
    text-indent: 1.5em;
    font-size: 25px;
    text-align: left;
    margin: 20px 0;
}
.text{
    line-height: 2;
}
.image1{
    width: 100%;
    margin: 50px 0;
}
</style>
